import { ScheduledDeliveryState } from '../api/shared';

export const getScheduleStateChipType = (
  state: ScheduledDeliveryState,
): 'primary' | 'warning' | 'error' | 'secondary' => {
  switch (state) {
    case ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE:
      return 'primary';
    case ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_PAUSED:
      return 'warning';
    case ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_CANCELLED:
      return 'error';
    default:
      return 'secondary';
  }
};

export const getScheduleStateLabel = (state: ScheduledDeliveryState): string => {
  switch (state) {
    case ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_ACTIVE:
      return 'Active';
    case ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_PAUSED:
      return 'Paused';
    case ScheduledDeliveryState.SCHEDULED_DELIVERY_STATE_CANCELLED:
      return 'Cancelled';
    default:
      return 'Unknown';
  }
};
